import React, { useContext } from 'react';
import { Button } from 'antd';
import calendarPng from 'assets/images/calendar.png';
import ModalEndSubmit from 'components/Organisms/Modals/ModalEndSubmit/ModalEndSubmit';
import { TaskOpenModalContext } from '../../../../Private';
import { TasksContext } from '../../../Dashboard';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { TaskState } from 'gql/graphql';

interface Props {
  visible: boolean;
  setVisible: Function;
  closeTask?: Function;
}

const ModalFinishTask = ({ visible, setVisible, closeTask }: Props) => {
  const { setHandler }: any = useContext(TaskOpenModalContext);
  const tasks: any[] = useContext(TasksContext);

  // Get Investment Experience verification task status
  const investmentExperienceTask = tasks?.find((task) => task.key === ModuleKeys.INVESTMENT_EXPERIENCE);
  const investmentExperienceStatus = investmentExperienceTask?.state;

  // Check if the "Take me to next approval task" button should be shown
  const shouldShowNextTaskButton = investmentExperienceStatus === TaskState.Draft || 
                                  investmentExperienceStatus === TaskState.Incomplete || 
                                  investmentExperienceStatus === TaskState.RequestError;

  return (
    <ModalEndSubmit
      visible={visible}
      setVisible={setVisible}
      buttonAction={{ hidden: true }}
      modal={{
        title: 'Great job!',
        description: (
          <h4 className="h4 h4-w4">
            {`You just completed a task. We´ll review the information you submitted and contact you if we need any changes.`}
          </h4>
        )
      }}
      className=""
      icon={calendarPng}
      buttonSubmit={
        shouldShowNextTaskButton ? (
          <Button
            htmlType="submit"
            className="button button-modal-ok"
            onClick={() => {
              setHandler('investment_experience')
              setVisible(false);
              if(closeTask)
                closeTask();
            }}
          >
            Take me to next approval task
          </Button>
        ) : (
          <Button
            htmlType="submit"
            className="button button-modal-ok"
            onClick={() => {
              setVisible(false);
              if(closeTask)
                closeTask();
            }}
          >
            Back to dashboard
          </Button>
        )
      }
      buttonCancel={
        <Button
          className="button button-modal-cancel"
          onClick={() => {
            setVisible(false);
            if(closeTask)
              closeTask();
          }}
        >
          Back to dashboard
        </Button>
      }
    />
  );
};
export default ModalFinishTask;
